// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23.0005 1.75439L12.0002 11.6546L1 1.75439V21H3V14H5V21H7V14H17V21H19V14H21V21H23L23.0005 1.75439Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-bridge-6-filled')
export default class Bridge6FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-6-filled',
    }
  }
}
